import { BaseError } from './base';

export function QueryError(message, debug, code, kinveyRequestId) {
  this.name = 'QueryError';
  this.message = message || 'An error occurred with the query.';
  this.debug = debug || undefined;
  this.code = code || undefined;
  this.kinveyRequestId = kinveyRequestId || undefined;
  this.stack = (new Error()).stack;
}
QueryError.prototype = Object.create(BaseError.prototype);
QueryError.prototype.constructor = QueryError;



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/errors/query.js